import { motion } from "framer-motion";
import { IMG } from "../config";
import { useLang } from "../i18n";

const FRAMES = [
  { src: IMG.terrace, en: "The terrace, after dark", ar: "التراس بعد الغروب", cls: "md:col-span-5 md:row-span-2", clip: true },
  { src: IMG.lattes, en: "Latte art, by hand", ar: "فن اللاتيه يدوياً", cls: "md:col-span-4" },
  { src: IMG.waffle, en: "Freshly baked waffles", ar: "وافل طازج يومياً", cls: "md:col-span-3" },
  { src: IMG.interior, en: "The reading corner", ar: "ركن القراءة", cls: "md:col-span-4", clip: true },
  { src: IMG.chess, en: "Beans, brew & books", ar: "بُنّ، قهوة وكتب", cls: "md:col-span-3" },
];

export const Gallery = () => {
  const { t, isAr } = useLang();
  return (
    <section id="gallery" className="py-24 md:py-32 px-6 md:px-12 max-w-[1400px] mx-auto" data-testid="gallery-section">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-14"
      >
        <p className="text-xs uppercase tracking-[0.35em] text-gold font-semibold mb-4">{t.gallery.kicker}</p>
        <h2 className="font-cinzel font-medium text-3xl md:text-5xl text-pine tracking-wide">
          {t.gallery.titleA} <span className="font-display italic font-light text-gold-shimmer tracking-tight">{t.gallery.titleB}</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:auto-rows-[280px]">
        {FRAMES.map((f, i) => (
          <motion.figure
            key={f.en}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`group relative overflow-hidden h-72 md:h-auto border border-line ${f.cls}`}
            style={f.clip ? { clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 32px), calc(100% - 32px) 100%, 0 100%)" } : undefined}
            data-testid={`gallery-frame-${i}`}
          >
            <img
              src={f.src}
              alt={f.en}
              loading="lazy"
              className="w-full h-full object-cover saturate-[0.92] brightness-95 transition-all duration-700 group-hover:saturate-110 group-hover:brightness-105 group-hover:scale-[1.06]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-forest/85 via-forest/10 to-transparent transition-opacity duration-500" />
            <figcaption className="absolute bottom-5 start-5 text-xs uppercase tracking-[0.28em] text-paper drop-shadow-sm translate-y-1 opacity-90 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
              {isAr ? f.ar : f.en}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
};
